import React, { useEffect, useRef, useState } from 'react';
import "../../Assets/CSS/Styles.scss";
import "../../Assets/CSS/Home.scss";
import onboardicon from "../../Assets/Images/Icons2/HowItWorksSection/onboard.png";
import automateicon from "../../Assets/Images/Icons2/HowItWorksSection/automated-process.png";
import analysisicon from "../../Assets/Images/Icons2/HowItWorksSection/analyze1.png";
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
const HowItWorks = () => {
  const [visibleCards, setVisibleCards] = useState([false, false, false]);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            visibleCards.forEach((_, index) => {
              setTimeout(() => {
                setVisibleCards((prev) => {
                  const newState = [...prev];
                  newState[index] = true;
                  return newState;
                });
              }, index * 300);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [visibleCards]);

  const steps = [
    {
      id: 1,
      title: "Onboard",
      desc1:
        "Quick setup and data migration with our expert team guiding you through every step.",
      desc2:
        "Complete setup in just ___ weeks with dedicated support and training for your staff.",
      icon: onboardicon,
    },
    {
      id: 2,
      title: "Automate",
      desc1:
        "Streamline all administrative processes from admissions to fee collection automatically.",
      desc2:
        "Reduce manual work by 80% with intelligent automation and workflow management.",
      icon: automateicon,
    },
    {
      id: 3,
      title: "Analyze",
      desc1:
        "Make data-driven decisions with comprehensive analytics and real-time insights.",
      desc2:
        "Access 50+ pre-built reports and custom dashboards for strategic planning.",
      icon: analysisicon,
    },
  ];

  return (

    <Container>

      <div>
       <div className="mx-auto px-6 sm:px-6 lg:px-20 py-8">
          {/* Header */}
          <div className="text-center mb-2">
            <h2 className="Headers font-ui">How It Works</h2>
            <p className="subHeads font-ui">
              Transform your institution in three simple steps with our proven
              implementation methodology
            </p>
          </div>

          <div
            className="relative py-8 sm:py-12 px-2 sm:px-6 lg:px-8"
            ref={sectionRef}
          >
            {/* Connecting line (desktop only) */}
            <div className="hidden md:flex absolute top-1/2 left-0 right-0 h-0 z-0 px-10">
              <div className="flex-1 border-t-4 border-solid border-amber-400 mx-16"></div>
            </div>

            {/* Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3  sm:gap-10 relative z-10">
              {steps.map((step) => (
                <div
                  key={step.id}
                  className="bg-white rounded-xl shadow-md p-4 sm:p-6 cardborder relative transition-all duration-300 hover:scale-105 hover:shadow-lg 
                           w-full mx-auto min-h-[300px] sm:min-h-[320px] mb-12 sm:mb-0"
                >
                  {/* Icon - Fixed positioning */}
                  <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 w-16 h-16">
                    <div className="flex items-center justify-center w-full h-full rounded-full bg-amber-100 border-2 border-white shadow-md">
                      <img
                        src={step.icon}
                        alt={`${step.title} icon`}
                        className="w-8 h-8 sm:w-9 sm:h-9 object-contain"
                      />
                    </div>
                  </div>

                  <div className="pt-12 sm:pt-8">
                    <div className="flex items-center justify-center mb-3">
                      <div className="stepCounter font-ui font-bold text-xs sm:text-sm w-[80px] sm:w-[100px] p-1 sm:p-2">
                        Step {step.id}
                      </div>
                    </div>
                    <h3 className="solutionTitle font-heading font-heading-bold text-center text-base sm:text-lg">
                      {step.title}
                    </h3>
                    <p className="step_p font-ui text-sm sm:text-base leading-relaxed">
                      {step.desc1}
                    </p>
                    <p className="step_subp text-sm sm:text-base leading-relaxed mt-2">
                      {step.desc2}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Button */}
          <div className="flex justify-center mt-4">
            <Link to="/freedemo">
              <button className="mt-2 text-[14px] font-bold demo-button bg-[#F59E0B] hover:bg-[#f3b541] font-ui">
                Start Your Transformation Today
              </button>
            </Link>
          </div>
        </div>
      </div>
    </Container>

  );
};

export default HowItWorks;